import { useEffect, useCallback } from 'react';

const SCROLL_THRESHOLD = 100;

export const useInfiniteScroll = (containerRef, { onLoadMore, hasMore, loading, loadingMore }) => {
  const handleScroll = useCallback(() => {
    const el = containerRef.current;
    if (!el || !hasMore || loading || loadingMore) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    if (scrollTop + clientHeight >= scrollHeight - SCROLL_THRESHOLD) {
      onLoadMore();
    }
  }, [containerRef, hasMore, loading, loadingMore, onLoadMore]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [containerRef, handleScroll]);
};
